console.log('%cHi there! ^_^', 'font-family: Arial, sans-serif; font-weight: bold; font-size: 20px');
console.log('%cWanna know how this was made? Click on the source line over there to know more.', 'font-family: Arial, sans-serif; font-size: 14px');
// Hey there, welcome, let's begin!

// Here, I've created a custom function to emulate a $document.ready() callback
// It ensures logic executes only when everything is properly loaded
const ready = (fn) => {
  if (document.readyState != 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

let canvas = document.getElementById('lifestream'),
  ctx = canvas.getContext('2d'),
  w, h, strands = [], sparkles = [],
  COLORS = ['#1affd1', '#00cc88', '#4dffdb'];

const init = () => {
  [w, h] = [canvas.width = window.innerWidth, canvas.height = window.innerHeight];
  strands = Array.from({ length: 8 }, () => ({
    y: h / 2, baseA: 40 + Math.random() * 80, off: Math.random() * 1000,
    spd: 0.5 + Math.random() * 1.5, thick: Math.random() * 1.5 + 0.5,
    col: COLORS[Math.floor(Math.random() * COLORS.length)]
  }));
  sparkles = [];
};

const draw = (t) => {
  // Clearing preserving transparency
  ctx.clearRect(0, 0, w, h);

  // Combined Update/Draw Loop
  strands.forEach(s => {
    ctx.beginPath();
    ctx.lineWidth = s.thick;
    ctx.strokeStyle = s.col;

    const getY = (x) => s.y + (
      Math.sin((x - s.off) * 0.005) +
      Math.sin((x - s.off) * 0.012 + s.off * 0.01)
    ) * s.baseA;

    // Regular points
    for (let x = 0; x < w; x += 15) {
      const y = getY(x);
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);

      if (Math.random() < 0.002) {
        sparkles.push({
          x, y,
          vx: (Math.random() - 0.5) * 2,
          vy: (Math.random() - 0.5) * 1.5,
          life: 1,
          dec: 0.005 + Math.random() * 0.005,
          sz: Math.random() * 2,
          col: s.col,
          wob: Math.random() * Math.PI
        });
      }
    }

    // Final point – only needed so the strand reaches the right edge
    const finalY = getY(w);
    ctx.lineTo(w, finalY);
    ctx.stroke();
    s.off += s.spd;
    s.y += Math.sin(t * 0.001) * 0.1;
  });

  // Sparkle update & draw in one reverse pass
  for (let i = sparkles.length - 1; i >= 0; i--) {
    let p = sparkles[i];
    p.life -= p.dec;
    if (p.life <= 0) { sparkles.splice(i, 1); continue; }

    p.x += p.vx + Math.sin(t * 0.002 + p.wob) * 0.5;
    p.y += p.vy;
    p.sz *= 0.99;

    ctx.globalAlpha = p.life;
    ctx.fillStyle = p.col;
    ctx.fillRect(p.x, p.y, p.sz * 2, p.sz * 2);
  }

  ctx.globalAlpha = 1;
  requestAnimationFrame(draw);
};

// This helper function handles the faint animation applied every time a value
// on the countdown changes. It ensures memory is used correctly.
const animateCSS = (element, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;

    element.classList.add(`${prefix}animated`, animationName);
    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      element.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    }
    element.addEventListener('animationend', handleAnimationEnd, { once: true });
  });

// The end of the countdown for FF7 Revelation, this date is being calculated
// against a fixed time and date regardless of user location.
// Every moving element has been separated and has its own variable.
let targetTime = localStorage.getItem('savedDate') ?? new Date('2027-04-08T00:00:00').getTime();
const daysValueElement = document.getElementById('days-value'),
  daysLabelElement = document.getElementById('days-label'),
  hoursValueElement = document.getElementById('hours-value'),
  hoursLabelElement = document.getElementById('hours-label'),
  minutesValueElement = document.getElementById('minutes-value'),
  minutesLabelElement = document.getElementById('minutes-label'),
  secondsValueElement = document.getElementById('seconds-value-integer'),
  secondsLabelElement = document.getElementById('seconds-label');

const getLocalizedUnit = (value, unit) => {
  // Setting undefined here uses the client's locale
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'unit',
    unit: unit,
    unitDisplay: 'long'
  });

  // formatToParts gives us a reliable way to extract only the unit part
  const parts = formatter.formatToParts(value);
  const unitPart = parts.find((p) => p.type === 'unit');

  return unitPart.value;
}

// This function is set to being executed every time the screen is refreshed
const updateCountdown = () => {
    const currentTime = new Date().getTime(),
      timeDifference = targetTime - currentTime;
    // Previously, the countdown included a decimal part when there was less than a minute left.
    // Now, it counts big. So counting down to one by the end feels like the right move.
    if (timeDifference > 1000) {
      const previousDays = parseInt(daysValueElement.innerText),
        previousHours = parseInt(hoursValueElement.innerText),
        previousMinutes = parseInt(minutesValueElement.innerText),
        previousSeconds = parseInt(secondsValueElement.innerText),
        days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((timeDifference % (1000 * 60)) / 1000),
        gradientStartTime = 1000 * 60 * 60 * 24 * 90,
        gradientOpacity = Math.min(1, Math.max(0, (gradientStartTime - (timeDifference)) / (gradientStartTime - 1000)));
      if (previousDays !== days) animateCSS(daysValueElement, 'pulse');
      if (previousHours !== hours) animateCSS(hoursValueElement, 'pulse');
      if (previousMinutes !== minutes) animateCSS(minutesValueElement, 'pulse');
      if (previousSeconds !== seconds)
        animateCSS(secondsValueElement, timeDifference > 60000 ? 'pulse' : 'final_countdown');
      if (days >= 1) {
        daysValueElement.innerText = days;
        daysLabelElement.innerText = getLocalizedUnit(days, 'day');
      } else if (document.getElementById('days')) {
        document.getElementById('days').remove();
      }
      if (timeDifference > 3600000) {
        hoursValueElement.innerText = hours;
        hoursLabelElement.innerText = getLocalizedUnit(hours, 'hour');
      } else if (document.getElementById('hours')) {
        document.getElementById('hours').remove();
      }
      if (timeDifference > 60000) {
        minutesValueElement.innerText = minutes;
        minutesLabelElement.innerText = getLocalizedUnit(minutes, 'minute');
      } else if (document.getElementById('minutes')) {
        document.getElementById('minutes').remove();
      }
      secondsValueElement.innerText = seconds;
      secondsLabelElement.innerText = getLocalizedUnit(seconds, 'second');
      if (timeDifference < 60000) {
        secondsValueElement.style.setProperty('--difference', seconds);
        if (document.getElementById('seconds-label'))
          document.getElementById('seconds-label').remove();
        document.body.style.backgroundImage = `linear-gradient(to top, rgba(37, 85, 100, ${gradientOpacity}), rgba(${parseInt(16 - (timeDifference / 60000) * 16)}, 0, 0, 1) 50%)`;
      } else if (timeDifference < gradientStartTime) {
        document.body.style.backgroundImage = `linear-gradient(to top, rgba(37, 85, 100, ${gradientOpacity}), rgba(0, 0, 0, 1) 50%)`;
      }
      // requestAnimationFrame will schedule updateCountdown to be run the next time the screen is repainted.
      requestAnimationFrame(updateCountdown);
    } else {
      const countdownElement = document.getElementById('countdown'),
        innerCountdown = document.createElement('div');
      innerCountdown.textContent = 'It\'s here!';
      countdownElement.classList.remove('w-100');
      countdownElement.replaceChildren(innerCountdown);
      countdownElement.style.fontSize = '15vw';
      countdownElement.classList.add('fw-bold', 'animate__animated', 'animate__bounceIn');
      document.body.style.backgroundImage = 'linear-gradient(to top, rgba(37, 85, 100, 1), rgb(16, 0, 0) 50%)';
    }
  // This will execute every time the screen is resized, as a utility to prevent styling artifacts on some screens.
  }, onWindowResize = () => {
    init();
    document.documentElement.classList.toggle('h-100', document.documentElement.scrollHeight <= window.innerHeight);
    document.body.classList.toggle('h-100', document.documentElement.scrollHeight <= window.innerHeight);
  }, getCustomDate = () => {
    const searchParams = new URLSearchParams(window.location.search),
      dateParam = searchParams.get('date');
    // Checking for date parameter value
    if (dateParam) {
      // ISO 8601 Regex validation (YYYY-MM-DDTHH:MM:SS)
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
      if (!isoRegex.test(dateParam)) {
        alert('Error: Incorrect date format.\nThe format must be: YYYY-MM-DDTHH:MM:SS');
        return null;
      }
      // Verify calendar validity (catches invalid dates like Feb 31)
      const dateObj = new Date(dateParam).getTime();
      if (isNaN(dateObj)) {
        alert('Error: Invalid date.');
        return null;
      }
      // If the string passed all the tests, it's valid and then assigned.
      targetTime = dateObj;
    // If date exists but has no value, spawn a calendar instead
    } else if (searchParams.has('date') && searchParams.get('date') === '') {
      const calendarModal = new bootstrap.Modal('#calendar-modal');
      // Basic quick-and-dirty validation
      document.getElementById('calendar').addEventListener('input', (event) => {
        const isDateInvalid = !event.target.value || event.target.validity.badInput;
        document.getElementById('calendar').classList.toggle('is-invalid', isDateInvalid);
        document.getElementById('calendar-confirm').disabled = isDateInvalid ? true : false;
      });
      calendarModal.show();
      document.getElementById('calendar-confirm').addEventListener('click', () => {
        targetTime = new Date(document.getElementById('calendar').value).getTime();
        if (document.getElementById('calendar-save').checked) {
        // If the calendar date was saved, remove the date argument to prevent
        // showing the calendar modal again on page reload
          const url = new URL(window.location.href);
          url.searchParams.delete('date');
          history.pushState(null, '', url);
          localStorage.setItem('savedDate', targetTime);
        }
        // Workaround: If the saved date was before the current date and the new date is after
        // the page must forced to be reloaded, as DOM elements has been removed
        if (document.getElementById('seconds-value-integer') === null)
          window.location.href = window.location.pathname;
      });
    }
  };

// This will be executed as soon as the document is loaded enough to use this logic with no issues
ready(() => {
  // This helper indicates how long it took to reach this point, starting with
  // console.time('DOMReady'), defined at the very beginning of the document
  console.timeEnd('DOMReady');
  // The following takes care of the loading spinner
  document.getElementById('loading').classList.add('loading-done');
  const currentYear = new Date().getFullYear();
  // This will initialize all bootstrap tooltips
  [...document.querySelectorAll('[data-bs-toggle="tooltip"]')].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  // This detects, validates and updates a custom target date if it was declared on the URL as an argument
  getCustomDate();
  // This handles the ticking down of the timer
  updateCountdown();
  // This will reinitialize the canvas to make it truly responsive
  window.onresize = onWindowResize;
  // This initializes the canvas drawing routines
  init();
  // And requestAnimationFrame() schedules a callback to execute right before the browser's next screen repaint
  requestAnimationFrame(draw);
  // This will modify the copyleft year, so it updates correctly from 2026 forwards
  if (currentYear > 2026) {
    document.getElementById('year').textContent = ` - ${currentYear}`;
  }
  // I hope this is enough for you to understand. If not, you can DM me at https://twitter.com/BreadMakerCTM. Cheers!
});